import styled from 'styled-components';

export const FirmInfoStyles = styled.div`
  display: flex;
  flex: 4;
  align-items: center;
  margin-top: ${({ mt }) => mt}px;
`;

export const Avatar = styled.div`
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  background-image: url(${({ src }) => src});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;

export const InfoContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  margin-left: 12px;
  margin-right: 10px;
`;

export const InfoRow1 = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  & > [class*='FirmName'],
  & > [class*='FirmDescription'] {
    margin-right: 4px;
  }
`;

export const InfoRow2 = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${({ mt }) => mt}px;
`;
